import React from 'react';
import Navbar from '../Navbar/Navbar';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Testimonials from '../Testimonials/Testimonials';
import About from '../About/About';
import Contact from '../Contact/Contact';
import FeaturedCategory from '../Categories/FeaturedCategory';
import Blog from '../Blog/Blog';
import Staff from '../Staff/Staff';



const Home = () => {
    return ( 
    <div>
      <Navbar />
      <Header />
      <About />
      <FeaturedCategory />
      <Blog />
      <Testimonials />
      <Staff />
      <Contact />
      <Footer />  
    </div>
     );
}
 
export default Home;